import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";
import PeerView from "./PeerView";
import { RootState } from "store";

interface MyPeerViewProps {
  style?: object,
  draggable?: boolean,
  x?: number,
  y?: number
}

const MyPeerView = ({ style, draggable, x, y }: MyPeerViewProps) => {
  const [videoStream, setVideoStream] = useState({ toURL: () => { } });
  const producers: any = useSelector((state: RootState) => state.live.settings.producers);
  const producersArray = Object.values(producers);
  const videoProducer: any = producersArray?.find(
    (producer: any) => producer.track.kind === 'video'
  );

  const addVideoTrack = () => {
    if (videoProducer) {
      const stream: any = new MediaStream();
      stream.addTrack(videoProducer.track);
      setVideoStream(stream);
    } else {
      setVideoStream({ toURL: () => { } });
    }
  };

  useEffect(() => {
    addVideoTrack();
  }, [videoProducer]);

  return (
    <div>
      {draggable ? (
        <Draggable defaultPosition={{ x, y }}>
          <div className="border border-white bg-black" style={{ borderWidth: 1 }}>
            <PeerView
              caller="myPeerView"
              style={style}
              streamURL={videoStream}
              peerEmail=""
              allStream={undefined}
              micIcon={false}
              isExpandedView={false}
              userDatax={undefined}
            />
          </div>
        </Draggable>
      ) : (
        <PeerView
          caller="myPeerView"
          style={{ ...style, backgroundColor: "#ffffff" }}
          streamURL={videoStream}
          peerEmail=""
          allStream={undefined}
          micIcon={false}
          isExpandedView={false}
          userDatax={undefined}
        />
      )}
    </div>
  );
};

export default MyPeerView;